/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AdType {
  BANNER = "BANNER",
  INTERSTITIAL = "INTERSTITIAL",
  MERGED_INTERSTITIAL = "MERGED_INTERSTITIAL",
  MREC = "MREC",
  NATIVE = "NATIVE",
  REWARDED_VIDEO = "REWARDED_VIDEO",
  VIDEO = "VIDEO",
}

export enum AdjustEnvironment {
  DEPENDS_ON_INSTALLER = "DEPENDS_ON_INSTALLER",
  PRODUCTION = "PRODUCTION",
  SANDBOX = "SANDBOX",
}

export enum AdmobAccountReportingStatus {
  DISABLED = "DISABLED",
  EMPTY_TOKENS = "EMPTY_TOKENS",
  INVALID_TOKENS = "INVALID_TOKENS",
  OK = "OK",
}

export enum AdmobSyncStatus {
  ACCOUNT_IS_NOT_SELECTED = "ACCOUNT_IS_NOT_SELECTED",
  RESYNC_NEEDED = "RESYNC_NEEDED",
  SYNCED = "SYNCED",
  SYNC_DISABLED = "SYNC_DISABLED",
  SYNC_FORBIDDEN = "SYNC_FORBIDDEN",
  SYNC_NEEDED = "SYNC_NEEDED",
}

export enum AppIntegrationStatus {
  FIRST_NETWORK_CONNECTED = "FIRST_NETWORK_CONNECTED",
  NOT_INTEGRATED = "NOT_INTEGRATED",
  SECOND_NETWORK_CONNECTED = "SECOND_NETWORK_CONNECTED",
}

export enum AppInterstitialMode {
  STATIC_ONLY = "STATIC_ONLY",
  VIDEO_AND_STATIC = "VIDEO_AND_STATIC",
  VIDEO_ONLY = "VIDEO_ONLY",
}

export enum AppSdkStatus {
  BETA = "BETA",
  BETA_OLD = "BETA_OLD",
  DEPRECATED = "DEPRECATED",
  NO_SDK = "NO_SDK",
  SUPPORTED = "SUPPORTED",
  UP_TO_DATE = "UP_TO_DATE",
  UP_TO_DATE_BETA = "UP_TO_DATE_BETA",
}

export enum AppSkAdNetworkStatus {
  BLANK = "BLANK",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  OUTDATED = "OUTDATED",
  UP_TO_DATE = "UP_TO_DATE",
}

export enum AppTestMode {
  ENABLED_FOR_AD_IDS_LIST = "ENABLED_FOR_AD_IDS_LIST",
  FORCE_DISABLED = "FORCE_DISABLED",
  FORCE_ENABLED = "FORCE_ENABLED",
  USE_SDK_SETTINGS = "USE_SDK_SETTINGS",
}

export enum AppodealAccountRequestStatus {
  APPROVED = "APPROVED",
  DENIED = "DENIED",
  NON_REVIEWED = "NON_REVIEWED",
}

export enum AppsPermissionsScope {
  CAN_SEE_STATS = "CAN_SEE_STATS",
  MANAGE_APPS = "MANAGE_APPS",
}

export enum AppsSortOrderBy {
  BUNDLE_ID = "BUNDLE_ID",
  ID = "ID",
  NAME = "NAME",
}

export enum AssetVariant {
  image = "image",
  video = "video",
}

export enum AttributionPlatform {
  ADJUST = "ADJUST",
  APPSFLYER = "APPSFLYER",
}

export enum AudienceGender {
  FEMALE = "FEMALE",
  MALE = "MALE",
}

export enum AutoPayoutModes {
  DISABLED = "DISABLED",
  IMMEDIATE = "IMMEDIATE",
  REGULAR = "REGULAR",
}

export enum BidManagerNetwork {
  ALL = "ALL",
  APPGROWTH = "APPGROWTH",
  APPLOVIN_INT = "APPLOVIN_INT",
  FACEBOOK = "FACEBOOK",
  GOOGLE = "GOOGLE",
}

export enum BidManagerNetworkTab {
  ALL = "ALL",
  APPGROWTH = "APPGROWTH",
  GOOGLE = "GOOGLE",
  META = "META",
}

export enum CRFilterDimension {
  APP = "APP",
  DESIGNER = "DESIGNER",
  FORMATS = "FORMATS",
  LANGUAGE = "LANGUAGE",
  NAME = "NAME",
  UPLOAD_ID = "UPLOAD_ID",
}

export enum CampaignStatus {
  ENABLED = "ENABLED",
  PAUSED = "PAUSED",
}

export enum CheckBidonCredentialsStatus {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum CheckMmpCredentialsStatus {
  FAILURE = "FAILURE",
  SUCCESS = "SUCCESS",
}

export enum DataAnonymizationMode {
  EDIT = "EDIT",
  OFF = "OFF",
  ON = "ON",
}

export enum DateDimension {
  APP_CREATED_DATE = "APP_CREATED_DATE",
  DATE = "DATE",
  INSTALL_DATE = "INSTALL_DATE",
  USER_CREATED_DATE = "USER_CREATED_DATE",
}

export enum DefaultMainPage {
  INTERNAL = "INTERNAL",
  MONETIZATION = "MONETIZATION",
  OVERVIEW = "OVERVIEW",
  REPORTS = "REPORTS",
}

export enum DeviceType {
  PHONE = "PHONE",
  TABLET = "TABLET",
}

export enum Dimension {
  AD_NETWORK = "AD_NETWORK",
  AD_REQUEST_FLOOR_RANGE = "AD_REQUEST_FLOOR_RANGE",
  AD_TYPE = "AD_TYPE",
  APP = "APP",
  APPODEAL_ACCOUNT = "APPODEAL_ACCOUNT",
  APP_CREATED_DATE = "APP_CREATED_DATE",
  APP_DETAILED = "APP_DETAILED",
  ATTRIBUTION_AD_SET = "ATTRIBUTION_AD_SET",
  ATTRIBUTION_AD_SET_HID = "ATTRIBUTION_AD_SET_HID",
  ATTRIBUTION_AGENCY = "ATTRIBUTION_AGENCY",
  ATTRIBUTION_CAMPAIGN = "ATTRIBUTION_CAMPAIGN",
  ATTRIBUTION_CAMPAIGN_HID = "ATTRIBUTION_CAMPAIGN_HID",
  ATTRIBUTION_CREATIVE = "ATTRIBUTION_CREATIVE",
  ATTRIBUTION_CREATIVE_HID = "ATTRIBUTION_CREATIVE_HID",
  ATTRIBUTION_NETWORK = "ATTRIBUTION_NETWORK",
  ATTRIBUTION_NETWORK_HID = "ATTRIBUTION_NETWORK_HID",
  ATTRIBUTION_PARTNER = "ATTRIBUTION_PARTNER",
  ATTRIBUTION_PARTNER_SOURCE = "ATTRIBUTION_PARTNER_SOURCE",
  ATTRIBUTION_SEARCH_KEYWORDS = "ATTRIBUTION_SEARCH_KEYWORDS",
  ATTRIBUTION_SEARCH_KEYWORDS_IDS = "ATTRIBUTION_SEARCH_KEYWORDS_IDS",
  ATTRIBUTION_SOURCE = "ATTRIBUTION_SOURCE",
  ATTRIBUTION_SOURCE_APP = "ATTRIBUTION_SOURCE_APP",
  AUTO_BID = "AUTO_BID",
  BIDMANAGER_CREATIVE_HID = "BIDMANAGER_CREATIVE_HID",
  BID_FLOOR_RANGE = "BID_FLOOR_RANGE",
  BID_PRICE_RANGE = "BID_PRICE_RANGE",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  COUNTRY = "COUNTRY",
  DATE = "DATE",
  DAY_SINCE_INSTALL = "DAY_SINCE_INSTALL",
  DEVICE_TYPE = "DEVICE_TYPE",
  DISPLAY_AD_TYPE = "DISPLAY_AD_TYPE",
  EVENT_NAME = "EVENT_NAME",
  EVENT_SOURCE = "EVENT_SOURCE",
  FRAMEWORK = "FRAMEWORK",
  FRAMEWORK_VERSION = "FRAMEWORK_VERSION",
  FUNNEL = "FUNNEL",
  HIST_AD_SET_AUTO_BID = "HIST_AD_SET_AUTO_BID",
  HIST_AD_SET_PAYBACK_PERIOD = "HIST_AD_SET_PAYBACK_PERIOD",
  HIST_AD_SET_STATUS = "HIST_AD_SET_STATUS",
  HIST_CAMPAIGN_AUTO_BID = "HIST_CAMPAIGN_AUTO_BID",
  HIST_CAMPAIGN_PAYBACK_PERIOD = "HIST_CAMPAIGN_PAYBACK_PERIOD",
  HIST_CAMPAIGN_STATUS = "HIST_CAMPAIGN_STATUS",
  HIST_CAMPAIGN_TYPE = "HIST_CAMPAIGN_TYPE",
  HIST_COUNTRY_AUTO_BID = "HIST_COUNTRY_AUTO_BID",
  HIST_COUNTRY_PAYBACK_PERIOD = "HIST_COUNTRY_PAYBACK_PERIOD",
  HIST_COUNTRY_STATUS = "HIST_COUNTRY_STATUS",
  HIST_SOURCE_APP_AUTO_BID = "HIST_SOURCE_APP_AUTO_BID",
  HIST_SOURCE_APP_PAYBACK_PERIOD = "HIST_SOURCE_APP_PAYBACK_PERIOD",
  HIST_SOURCE_APP_STATUS = "HIST_SOURCE_APP_STATUS",
  INSTALL_DATE = "INSTALL_DATE",
  INSTALL_MEDIATION = "INSTALL_MEDIATION",
  INSTALL_PACKAGE_VERSION = "INSTALL_PACKAGE_VERSION",
  IS_CHARDONNAY = "IS_CHARDONNAY",
  IS_CLAIMED_BY_PUBLISHER = "IS_CLAIMED_BY_PUBLISHER",
  IS_ORGANIC = "IS_ORGANIC",
  KEYWORDS = "KEYWORDS",
  LINE_ITEM = "LINE_ITEM",
  MANUFACTURER = "MANUFACTURER",
  MEDIATION = "MEDIATION",
  MEDIATION_GROUP = "MEDIATION_GROUP",
  MMP = "MMP",
  MODEL = "MODEL",
  MONETIZATION_ENGINE = "MONETIZATION_ENGINE",
  NETWORK_ACCOUNT = "NETWORK_ACCOUNT",
  OS = "OS",
  OS_VERSION = "OS_VERSION",
  PACKAGE_VERSION = "PACKAGE_VERSION",
  PARALLEL_BIDDING = "PARALLEL_BIDDING",
  PLACEMENT = "PLACEMENT",
  PLUGIN_VERSION = "PLUGIN_VERSION",
  POST_BID = "POST_BID",
  REVENUE_MANAGER = "REVENUE_MANAGER",
  ROUND_NUMBER = "ROUND_NUMBER",
  SDK_VERSION = "SDK_VERSION",
  SEGMENT = "SEGMENT",
  STUDIO = "STUDIO",
  UA_STATUS = "UA_STATUS",
  USER = "USER",
  USER_CREATED_DATE = "USER_CREATED_DATE",
  WATERFALL_CONFIGURATION = "WATERFALL_CONFIGURATION",
  WHITE_LABEL_PUBLISHER = "WHITE_LABEL_PUBLISHER",
  ZERO_IDFA = "ZERO_IDFA",
  ZERO_MMP_ID = "ZERO_MMP_ID",
}

export enum ExperimentStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  STOPPED = "STOPPED",
}

export enum FacebookAccountReportingStatus {
  DISABLED = "DISABLED",
  EMPTY_TOKEN = "EMPTY_TOKEN",
  EXPIRING_SOON_TOKEN = "EXPIRING_SOON_TOKEN",
  INVALID_TOKEN = "INVALID_TOKEN",
  OK = "OK",
}

export enum FilterDimension {
  AD_NETWORK = "AD_NETWORK",
  AD_REQUEST_FLOOR_RANGE = "AD_REQUEST_FLOOR_RANGE",
  AD_TYPE = "AD_TYPE",
  APP = "APP",
  APPODEAL_ACCOUNT = "APPODEAL_ACCOUNT",
  APP_CREATED_DATE = "APP_CREATED_DATE",
  APP_DETAILED = "APP_DETAILED",
  ATTRIBUTION_AD_SET = "ATTRIBUTION_AD_SET",
  ATTRIBUTION_AD_SET_HID = "ATTRIBUTION_AD_SET_HID",
  ATTRIBUTION_AGENCY = "ATTRIBUTION_AGENCY",
  ATTRIBUTION_CAMPAIGN = "ATTRIBUTION_CAMPAIGN",
  ATTRIBUTION_CAMPAIGN_HID = "ATTRIBUTION_CAMPAIGN_HID",
  ATTRIBUTION_CREATIVE = "ATTRIBUTION_CREATIVE",
  ATTRIBUTION_CREATIVE_HID = "ATTRIBUTION_CREATIVE_HID",
  ATTRIBUTION_NETWORK = "ATTRIBUTION_NETWORK",
  ATTRIBUTION_NETWORK_HID = "ATTRIBUTION_NETWORK_HID",
  ATTRIBUTION_PARTNER = "ATTRIBUTION_PARTNER",
  ATTRIBUTION_PARTNER_SOURCE = "ATTRIBUTION_PARTNER_SOURCE",
  ATTRIBUTION_SEARCH_KEYWORDS = "ATTRIBUTION_SEARCH_KEYWORDS",
  ATTRIBUTION_SEARCH_KEYWORDS_IDS = "ATTRIBUTION_SEARCH_KEYWORDS_IDS",
  ATTRIBUTION_SOURCE = "ATTRIBUTION_SOURCE",
  ATTRIBUTION_SOURCE_APP = "ATTRIBUTION_SOURCE_APP",
  AUTO_BID = "AUTO_BID",
  BIDMANAGER_CREATIVE_HID = "BIDMANAGER_CREATIVE_HID",
  BID_FLOOR_RANGE = "BID_FLOOR_RANGE",
  BID_PRICE_RANGE = "BID_PRICE_RANGE",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  COUNTRY = "COUNTRY",
  DAY_SINCE_INSTALL = "DAY_SINCE_INSTALL",
  DEVICE_TYPE = "DEVICE_TYPE",
  DISPLAY_AD_TYPE = "DISPLAY_AD_TYPE",
  EVENT_NAME = "EVENT_NAME",
  EVENT_SOURCE = "EVENT_SOURCE",
  FRAMEWORK = "FRAMEWORK",
  FRAMEWORK_VERSION = "FRAMEWORK_VERSION",
  FUNNEL = "FUNNEL",
  HIST_AD_SET_AUTO_BID = "HIST_AD_SET_AUTO_BID",
  HIST_AD_SET_PAYBACK_PERIOD = "HIST_AD_SET_PAYBACK_PERIOD",
  HIST_AD_SET_STATUS = "HIST_AD_SET_STATUS",
  HIST_CAMPAIGN_AUTO_BID = "HIST_CAMPAIGN_AUTO_BID",
  HIST_CAMPAIGN_PAYBACK_PERIOD = "HIST_CAMPAIGN_PAYBACK_PERIOD",
  HIST_CAMPAIGN_STATUS = "HIST_CAMPAIGN_STATUS",
  HIST_CAMPAIGN_TYPE = "HIST_CAMPAIGN_TYPE",
  HIST_COUNTRY_AUTO_BID = "HIST_COUNTRY_AUTO_BID",
  HIST_COUNTRY_PAYBACK_PERIOD = "HIST_COUNTRY_PAYBACK_PERIOD",
  HIST_COUNTRY_STATUS = "HIST_COUNTRY_STATUS",
  HIST_SOURCE_APP_AUTO_BID = "HIST_SOURCE_APP_AUTO_BID",
  HIST_SOURCE_APP_PAYBACK_PERIOD = "HIST_SOURCE_APP_PAYBACK_PERIOD",
  HIST_SOURCE_APP_STATUS = "HIST_SOURCE_APP_STATUS",
  INSTALL_MEDIATION = "INSTALL_MEDIATION",
  INSTALL_PACKAGE_VERSION = "INSTALL_PACKAGE_VERSION",
  IS_CHARDONNAY = "IS_CHARDONNAY",
  IS_CLAIMED_BY_PUBLISHER = "IS_CLAIMED_BY_PUBLISHER",
  IS_ORGANIC = "IS_ORGANIC",
  KEYWORDS = "KEYWORDS",
  LINE_ITEM = "LINE_ITEM",
  MANUFACTURER = "MANUFACTURER",
  MEDIATION = "MEDIATION",
  MEDIATION_GROUP = "MEDIATION_GROUP",
  MMP = "MMP",
  MODEL = "MODEL",
  MONETIZATION_ENGINE = "MONETIZATION_ENGINE",
  NETWORK_ACCOUNT = "NETWORK_ACCOUNT",
  OS = "OS",
  OS_VERSION = "OS_VERSION",
  PACKAGE_VERSION = "PACKAGE_VERSION",
  PARALLEL_BIDDING = "PARALLEL_BIDDING",
  PLACEMENT = "PLACEMENT",
  PLUGIN_VERSION = "PLUGIN_VERSION",
  POST_BID = "POST_BID",
  REVENUE_MANAGER = "REVENUE_MANAGER",
  ROUND_NUMBER = "ROUND_NUMBER",
  SDK_VERSION = "SDK_VERSION",
  SEGMENT = "SEGMENT",
  STUDIO = "STUDIO",
  UA_STATUS = "UA_STATUS",
  USER = "USER",
  USER_CREATED_DATE = "USER_CREATED_DATE",
  WATERFALL_CONFIGURATION = "WATERFALL_CONFIGURATION",
  WHITE_LABEL_PUBLISHER = "WHITE_LABEL_PUBLISHER",
  ZERO_IDFA = "ZERO_IDFA",
  ZERO_MMP_ID = "ZERO_MMP_ID",
}

export enum FunnelFilterDimension {
  APP = "APP",
  ATTRIBUTION_AD_SET = "ATTRIBUTION_AD_SET",
  ATTRIBUTION_AD_SET_HID = "ATTRIBUTION_AD_SET_HID",
  ATTRIBUTION_CAMPAIGN = "ATTRIBUTION_CAMPAIGN",
  ATTRIBUTION_CAMPAIGN_HID = "ATTRIBUTION_CAMPAIGN_HID",
  ATTRIBUTION_CREATIVE = "ATTRIBUTION_CREATIVE",
  ATTRIBUTION_CREATIVE_HID = "ATTRIBUTION_CREATIVE_HID",
  ATTRIBUTION_NETWORK = "ATTRIBUTION_NETWORK",
  ATTRIBUTION_NETWORK_HID = "ATTRIBUTION_NETWORK_HID",
  ATTRIBUTION_SOURCE = "ATTRIBUTION_SOURCE",
  ATTRIBUTION_SOURCE_APP = "ATTRIBUTION_SOURCE_APP",
  CONNECTION_TYPE = "CONNECTION_TYPE",
  COUNTRY = "COUNTRY",
  KEYWORDS = "KEYWORDS",
  MANUFACTURER = "MANUFACTURER",
  MODEL = "MODEL",
  OS = "OS",
  USER = "USER",
  ZERO_IDFA = "ZERO_IDFA",
}

export enum FunnelVariant {
  FUNNEL = "FUNNEL",
  INTERSECTION = "INTERSECTION",
}

export enum HavingFilterOperator {
  EQUAL = "EQUAL",
  LESS = "LESS",
  LESS_OR_EQUAL = "LESS_OR_EQUAL",
  MORE = "MORE",
  MORE_OR_EQUAL = "MORE_OR_EQUAL",
  NOT_EQUAL = "NOT_EQUAL",
}

export enum MMP {
  ADJUST = "ADJUST",
  APPSFLYER = "APPSFLYER",
}

export enum MediationEngine {
  APPLOVIN_MAX = "APPLOVIN_MAX",
  APPODEAL = "APPODEAL",
  BIDON = "BIDON",
  LEVEL_PLAY = "LEVEL_PLAY",
}

export enum MediationGroupTarget {
  COUNTRIES = "COUNTRIES",
  DEFAULT = "DEFAULT",
  SEGMENTS = "SEGMENTS",
}

export enum MonetizationEngine {
  APPLOVIN_MAX = "APPLOVIN_MAX",
  APPODEAL = "APPODEAL",
  BIDON = "BIDON",
  LEVEL_PLAY = "LEVEL_PLAY",
}

export enum MopubDimension {
  MREC = "MREC",
  PHONE_BANNER = "PHONE_BANNER",
  PHONE_INTERSTITIAL_LANDSCAPE = "PHONE_INTERSTITIAL_LANDSCAPE",
  PHONE_INTERSTITIAL_PORTRAIT = "PHONE_INTERSTITIAL_PORTRAIT",
  TABLET_BANNER = "TABLET_BANNER",
  TABLET_INTERSTITIAL_LANDSCAPE = "TABLET_INTERSTITIAL_LANDSCAPE",
  TABLET_INTERSTITIAL_PORTRAIT = "TABLET_INTERSTITIAL_PORTRAIT",
}

export enum NewLineItemTargetConfiguration {
  ALL = "ALL",
  DEFAULT = "DEFAULT",
}

export enum PaymentRequestStatuses {
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
  FRAUD_ACTIVITY = "FRAUD_ACTIVITY",
  HOLD = "HOLD",
  PROCESSING = "PROCESSING",
  REJECTED = "REJECTED",
  REQUESTED = "REQUESTED",
  RISKY = "RISKY",
  SCHEDULED = "SCHEDULED",
}

export enum PaymentRequestTypes {
  IMMEDIATE = "IMMEDIATE",
  REGULAR = "REGULAR",
}

export enum Platform {
  AMAZON = "AMAZON",
  GOOGLE = "GOOGLE",
  IOS = "IOS",
}

export enum RawDataSource {
  GLOBAL_CALLBACK = "GLOBAL_CALLBACK",
  S3 = "S3",
}

export enum RefreshStoreInfoStatus {
  ERROR = "ERROR",
  FOUND = "FOUND",
  NOT_FOUND = "NOT_FOUND",
}

export enum ReportEventType {
  ACCOUNT_REFILL = "ACCOUNT_REFILL",
  ADVERTISEMENT_INCOME = "ADVERTISEMENT_INCOME",
  ADVERTISEMENT_SPENDINGS = "ADVERTISEMENT_SPENDINGS",
  AFFILIATE_INCOME = "AFFILIATE_INCOME",
  APP_SHARE_INCOME = "APP_SHARE_INCOME",
  BONUS_INCOME = "BONUS_INCOME",
  FRAUD_CHARGES_AMOUNT = "FRAUD_CHARGES_AMOUNT",
  FROZEN_PAYOUTS_AMOUNT = "FROZEN_PAYOUTS_AMOUNT",
  IMMEDIATE_PAYOUTS_AMOUNT = "IMMEDIATE_PAYOUTS_AMOUNT",
  INTEGRATION_BONUS_INCOME = "INTEGRATION_BONUS_INCOME",
  MANUAL_RECALCULATIONS = "MANUAL_RECALCULATIONS",
  MEDIATION_FEE = "MEDIATION_FEE",
  REGULAR_PAYOUTS_AMOUNT = "REGULAR_PAYOUTS_AMOUNT",
}

export enum SavedDateFilterPeriods {
  ALL_TIME = "ALL_TIME",
  EXACT_DATES = "EXACT_DATES",
  LAST_14_DAYS = "LAST_14_DAYS",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_60_DAYS = "LAST_60_DAYS",
  LAST_7_DAYS = "LAST_7_DAYS",
  LAST_90_DAYS = "LAST_90_DAYS",
  LAST_MONTH = "LAST_MONTH",
  LAST_QUARTER = "LAST_QUARTER",
  LAST_WEEK = "LAST_WEEK",
  LAST_YEAR = "LAST_YEAR",
  THIS_MONTH = "THIS_MONTH",
  THIS_QUARTER = "THIS_QUARTER",
  THIS_WEEK = "THIS_WEEK",
  THIS_YEAR = "THIS_YEAR",
  TODAY = "TODAY",
  YESTERDAY = "YESTERDAY",
}

export enum SmaatoDimension {
  FULLSCREEN_INTERSTITIAL_LANDSCAPE = "FULLSCREEN_INTERSTITIAL_LANDSCAPE",
  FULLSCREEN_INTERSTITIAL_PORTRAIT = "FULLSCREEN_INTERSTITIAL_PORTRAIT",
  LARGE = "LARGE",
  LEADERBOARD = "LEADERBOARD",
  MEDIUM = "MEDIUM",
  MEDIUM_RECTANGLE = "MEDIUM_RECTANGLE",
  SKYSCRAPER = "SKYSCRAPER",
  SMALL = "SMALL",
  TABLET_FULLSCREEN_INTERSTITIAL_LANDSCAPE = "TABLET_FULLSCREEN_INTERSTITIAL_LANDSCAPE",
  TABLET_FULLSCREEN_INTERSTITIAL_PORTRAIT = "TABLET_FULLSCREEN_INTERSTITIAL_PORTRAIT",
  WIDE_SKYSCRAPER = "WIDE_SKYSCRAPER",
  XLARGE = "XLARGE",
  XXLARGE = "XXLARGE",
}

export enum SortOrderDirection {
  ASC = "ASC",
  DESC = "DESC",
  asc = "asc",
  desc = "desc",
}

export enum TestResultStatus {
  FAIL = "FAIL",
  FOR_TEST = "FOR_TEST",
  GOOD = "GOOD",
  NOT_FOR_TEST = "NOT_FOR_TEST",
  REJECTED = "REJECTED",
  TESTING = "TESTING",
}

export enum ThemeMode {
  DARK = "DARK",
  LIGHT = "LIGHT",
}

export enum TimeBucket {
  DAY = "DAY",
  MONTH = "MONTH",
  QUARTER = "QUARTER",
  WEEK = "WEEK",
}

export enum TopFilterOrder {
  BottomValues = "BottomValues",
  TopValues = "TopValues",
}

export enum TwoFactorChallengeType {
  DISABLED = "DISABLED",
  EMAIL = "EMAIL",
  ONE_TIME_PASSWORD = "ONE_TIME_PASSWORD",
}

export enum UaAccountStatus {
  ACTIVE = "ACTIVE",
  INVALID_TOKENS = "INVALID_TOKENS",
}

export enum UaEntityClass {
  UA_AD_SET = "UA_AD_SET",
  UA_CAMPAIGN = "UA_CAMPAIGN",
  UA_CAMPAIGN_COUNTRY = "UA_CAMPAIGN_COUNTRY",
  UA_CAMPAIGN_COUNTRY_SOURCE_APP = "UA_CAMPAIGN_COUNTRY_SOURCE_APP",
}

export enum UaNetwork {
  APPGROWTH = "APPGROWTH",
  FACEBOOK = "FACEBOOK",
  GOOGLE_ADS = "GOOGLE_ADS",
  UNITY = "UNITY",
}

export enum WaterfallConfigurationBiddingStrategy {
  AUTO = "AUTO",
  MANUAL = "MANUAL",
}

export enum WaterfallConfigurationTarget {
  COUNTRIES = "COUNTRIES",
  DEFAULT = "DEFAULT",
  SEGMENTS = "SEGMENTS",
}

export enum WorkerStatus {
  ERROR = "ERROR",
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
}

export interface AppAttributionSettingsAttributes {
  adjustAppToken?: string | null;
  adjustEnvironment?: AdjustEnvironment | null;
  adjustS2sToken?: string | null;
  appsflyerAppId?: string | null;
  appsflyerConversionKeys?: string[] | null;
  appsflyerDevKey?: string | null;
  attributionPlatform?: AttributionPlatform | null;
  enableStackAttribution: boolean;
  facebookTracking?: boolean | null;
  firebaseAdRevenueKey?: string | null;
  firebaseConfigKeys?: string[] | null;
  firebaseExpirationDuration?: number | null;
  firebaseTracking?: boolean | null;
  getSpendFromSecondaryMmpAccount: boolean;
  iapCustomEvents?: string[] | null;
  iapRevenueAppStoreFeePercent?: number | null;
  primaryMmpAccount?: string | null;
  primaryMmpRawDataSource?: RawDataSource | null;
  secondaryMmpAccount?: string | null;
  secondaryMmpRawDataSource?: RawDataSource | null;
  sendAfAdRevenue: boolean;
  sendAfAdRevenueAttribution: boolean;
  unityS2sIntegration: boolean;
}

export interface AppNetworkAccountAttributes {
  adcolonyAppId?: string | null;
  admobAppId?: string | null;
  amazonKey?: string | null;
  bigoAdsAppId?: string | null;
  chartboostId?: string | null;
  chartboostSignature?: string | null;
  facebookAppId?: string | null;
  facebookAppSecret?: string | null;
  flurryKey?: string | null;
  fyberAppId?: string | null;
  gamAppKey?: string | null;
  inmobiKey?: string | null;
  mobvistaAppId?: string | null;
  molocoAppKey?: string | null;
  mopubAppKey?: string | null;
  notsyAppKey?: string | null;
  oguryAppKey?: string | null;
  pangleAppId?: string | null;
  pubmaticAppId?: string | null;
  pubnativeId?: string | null;
  pubnativeKey?: string | null;
  reklamUpAppId?: string | null;
  remoteAppKey?: string | null;
  startappAppId?: string | null;
  tapjoyAppKey?: string | null;
  tapjoySdkKey?: string | null;
  targetPadGroupId?: string | null;
  unityAdsId?: string | null;
  vungleAppId?: string | null;
  yandexAppId?: string | null;
  yandexMetricaId?: string | null;
  yandexNewMetricaId?: string | null;
}

export interface AutoPayoutSettingsInput {
  immediateThreshold?: number | null;
  payoutMode: AutoPayoutModes;
  regularPaymentLimit?: number | null;
  regularPayoutThreshold?: number | null;
}

export interface BidonInstanceAttributes {
  apiKey: string;
  endpoint: string;
  name: string;
}

export interface BudgetChange {
  budget: number;
  id: string;
}

export interface CPAMetaData {
  isAbsoluteChange: boolean;
  isMassAction: boolean;
  relativeChange?: number | null;
}

export interface CampaignCreativeInput {
  callToAction?: string | null;
  campaignName?: string | null;
  headline?: string | null;
  id: string;
  primaryText?: string | null;
}

export interface CampaignFiltersInput {
  appId?: TextFilter | null;
  appName?: TextFilter | null;
  appgrowthCreativeHash?: TextFilter | null;
  createdAt?: TextFilter | null;
  id?: TextFilter | null;
  mode?: TextFilter | null;
  name?: TextFilter | null;
  networkType?: TextFilter | null;
  userDataEmail?: TextFilter | null;
}

export interface CampaignInput {
  appIds: string[];
  audienceGender?: AudienceGender | null;
  audienceMaxAge?: number | null;
  audienceMinAge?: number | null;
  creatives: CampaignCreativeInput[];
  fbEventType?: string | null;
  mode: string;
  name?: string | null;
  networkType?: string | null;
  sourceAppsBundleIds?: string[] | null;
  targetCountryIds: string[];
  targetEventName?: string | null;
  type?: string | null;
}

export interface ChangeLogFilterInput {
  include: boolean;
  values: string[];
}

export interface CpaChange {
  cpa: number;
  id: string;
}

export interface CreateAppAttributes {
  bundleId?: string | null;
  coppa?: boolean | null;
  disableNetworksAutoconnection?: boolean | null;
  filterMatureContent?: boolean | null;
  mediationEngine?: MediationEngine | null;
  name?: string | null;
  ownerId?: string | null;
  platform?: Platform | null;
}

export interface CreateExperimentGroupInput {
  isControl: boolean;
  name: string;
}

export interface CreateExperimentInput {
  cohortLife: number;
  description?: string | null;
  groups: CreateExperimentGroupInput[];
  name: string;
  waterfallConfigurationId: string;
}

export interface CreativeAdAssetUploadInput {
  aspectRatio: string;
  createdAt?: string | null;
  file?: any | null;
  fileName?: string | null;
  updatedAt?: string | null;
  url?: string | null;
}

export interface CreativeAdSetUploadInput {
  apps: string[];
  assets: CreativeAdAssetUploadInput[];
  designerId?: string | null;
  name: string;
}

export interface CreativeBulkUploadInput {
  creatives: CreativeAdSetUploadInput[];
  driveLink?: string | null;
}

export interface CreativeFileInput {
  aspectRatio: string;
  file: any;
  fileType: string;
  network: string;
}

export interface CreativeFiltersInput {
  appId?: TextFilter | null;
  appName?: TextFilter | null;
  appgrowthStatus?: TextFilter | null;
  createdAt?: TextFilter | null;
  designerName?: TextFilter | null;
  facebookStatus?: TextFilter | null;
  id?: TextFilter | null;
  isBest?: TextableBooleanFilter | null;
  language?: TextFilter | null;
  name?: TextFilter | null;
  status?: TextFilter | null;
  userDataEmail?: TextFilter | null;
}

export interface CreativeInput {
  appIds: string[];
  appgrowthTargetCountryIds: string[];
  designerId?: string | null;
  fileIds: string[];
  files: CreativeFileInput[];
  id?: string | null;
  language: number;
  name: string;
  sourceAppsBundleIds?: string[] | null;
  status: string;
  theme?: string | null;
}

export interface CreativeLibraryFilterInput {
  dimension: string;
  include: boolean;
  searchByString?: string | null;
  values?: string[] | null;
}

export interface CreativeLibraryFilters {
  app?: CreativeLibraryFilterInput | null;
  createdAt?: DateFilterInput | null;
  designer?: CreativeLibraryFilterInput | null;
  formats?: CreativeLibraryFilterInput | null;
  ids?: CreativeLibraryFilterInput | null;
  language?: CreativeLibraryFilterInput | null;
  name?: CreativeLibraryFilterInput | null;
  network?: CreativeLibraryFilterInput | null;
  networkStatus?: CreativeLibraryFilterInput | null;
  onGoingCampaignCount?: CreativeLibraryFilterInput | null;
  status?: CreativeLibraryFilterInput | null;
  testCampaignsCount?: CreativeLibraryFilterInput | null;
  uploadId?: CreativeLibraryFilterInput | null;
}

export interface CreativeTestParams {
  creativeId: string;
  testFlowId: string;
}

export interface DateFilterInput {
  dimension: DateDimension;
  from: any;
  include: boolean;
  to: any;
}

export interface EcpmPriorityLineAttributes {
  ecpm: number;
  id: string;
}

export interface ExistingLineItemAttributes {
  appChannel?: string | null;
  code?: string | null;
  countries?: string[] | null;
  dimension?: SmaatoDimension | null;
  ecpm: number;
  flurrySpaceId?: string | null;
  isInstance?: boolean | null;
  label: string;
  mediationEngines?: MediationEngine[] | null;
  mopubDimension?: MopubDimension | null;
  overriddenAdType?: AdType | null;
  placementId?: string | null;
  placementName?: string | null;
  siteId?: string | null;
  smaatoDimension?: SmaatoDimension | null;
  spotId?: string | null;
  targetingKey?: string | null;
}

export interface ExistingMediationGroupAttributes {
  countryIds?: string[] | null;
  name: string;
  roundsConfig?: MediationRoundConfigAttributes[] | null;
  segmentIds?: string[] | null;
  target?: MediationGroupTarget | null;
}

export interface ExistingMmpAccountAttributes {
  masterApiToken?: string | null;
  name: string;
  s3AccessKeyId?: string | null;
  s3BucketName?: string | null;
  s3HomeFolder?: string | null;
  s3Region?: string | null;
  s3SecretAccessKey?: string | null;
  useS3?: boolean | null;
  userToken?: string | null;
}

export interface ExistingUserNetworkAccountAttributes {
  accountId?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  clientId?: string | null;
  clientKey?: string | null;
  clientSecret?: string | null;
  consumerKey?: string | null;
  consumerSecret?: string | null;
  devId?: string | null;
  newAccessToken?: string | null;
  oauthToken?: string | null;
  organizationCoreId?: string | null;
  partnerId?: string | null;
  password?: string | null;
  publisherId?: string | null;
  publisherReportingApiKey?: string | null;
  refreshToken?: string | null;
  reportKey?: string | null;
  reportToken?: string | null;
  reportingApiToken?: string | null;
  reportingSecretKey?: string | null;
  s3AccessKeyId?: string | null;
  s3Location?: string | null;
  s3SecretAccessKey?: string | null;
  sKey?: string | null;
  sdkKey?: string | null;
  secretKey?: string | null;
  token?: string | null;
  userId?: string | null;
  userSignature?: string | null;
}

export interface ExistingWaterfallConfigurationAttributes {
  biddingPriceFloors?: number[] | null;
  biddingStrategy?: WaterfallConfigurationBiddingStrategy | null;
  countryIds?: string[] | null;
  enableBidding?: boolean | null;
  enablePostBid?: boolean | null;
  enablePostBidAutoPriceFloorSteps?: boolean | null;
  lineItems: WaterfallConfigurationLineItemsAttributes;
  name: string;
  postBidPriceFloorSteps?: number[] | null;
  segmentIds?: string[] | null;
  skipAdmobEmergencyAlgorithm?: boolean | null;
  target?: WaterfallConfigurationTarget | null;
  useMaxMonetizationEngine?: boolean | null;
}

export interface FilterInput {
  dimension: FilterDimension;
  include: boolean;
  searchByString?: string | null;
  values: string[];
}

export interface FunnelAttributes {
  dateFilters: DateFilterInput;
  filters: FilterInput[];
  funnelSteps: FunnelStepInput[];
  funnelVariant: FunnelVariant;
}

export interface FunnelFilterInput {
  dimension: FunnelFilterDimension;
  include: boolean;
  searchByString?: string | null;
  values: string[];
}

export interface FunnelStepInput {
  eventName: string;
  include: boolean;
  maxDaysSinceInstall?: number | null;
  minTimesOccurred?: number | null;
}

export interface GroupByInput {
  dimension: Dimension;
  timeBucket?: TimeBucket | null;
}

export interface HavingFilterInput {
  measure: RichMeasureInput;
  operator: HavingFilterOperator;
  value?: number | null;
}

export interface ManualPriorityLineAttributes {
  lineItems: string[];
}

export interface MarketingData {
  appLink?: string | null;
  companyName?: string | null;
  companySize?: string | null;
  hearAboutUs?: string | null;
  messenger?: string | null;
  messengerPhoneOrNickname?: string | null;
}

export interface MediationRoundConfigAttributes {
  mediation: MediationEngine;
  roundNumber: number;
}

export interface NewLineItemAttributes {
  appChannel?: string | null;
  code?: string | null;
  countries?: string[] | null;
  deviceType?: DeviceType | null;
  dimension?: SmaatoDimension | null;
  ecpm: number;
  flurrySpaceId?: string | null;
  isInstance?: boolean | null;
  isParallelBidding?: boolean | null;
  label: string;
  mediationEngines?: MediationEngine[] | null;
  mopubDimension?: MopubDimension | null;
  overriddenAdType?: AdType | null;
  placementId?: string | null;
  placementName?: string | null;
  siteId?: string | null;
  smaatoDimension?: SmaatoDimension | null;
  spotId?: string | null;
  targetingKey?: string | null;
}

export interface NewMediationGroupAttributes {
  copiedById?: string | null;
  countryIds?: string[] | null;
  name: string;
  roundsConfig: MediationRoundConfigAttributes[];
  segmentIds?: string[] | null;
  target: MediationGroupTarget;
}

export interface NewMmpAccountAttributes {
  masterApiToken?: string | null;
  name: string;
  s3AccessKeyId?: string | null;
  s3BucketName?: string | null;
  s3HomeFolder?: string | null;
  s3Region?: string | null;
  s3SecretAccessKey?: string | null;
  useS3?: boolean | null;
  userToken?: string | null;
}

export interface NewUserNetworkAccountAttributes {
  accountId?: string | null;
  apiKey?: string | null;
  apiSecret?: string | null;
  clientId?: string | null;
  clientKey?: string | null;
  clientSecret?: string | null;
  consumerKey?: string | null;
  consumerSecret?: string | null;
  devId?: string | null;
  login: string;
  newAccessToken?: string | null;
  oauthToken?: string | null;
  organizationCoreId?: string | null;
  partnerId?: string | null;
  password?: string | null;
  publisherId?: string | null;
  publisherReportingApiKey?: string | null;
  refreshToken?: string | null;
  reportKey?: string | null;
  reportToken?: string | null;
  reportingApiToken?: string | null;
  reportingSecretKey?: string | null;
  s3AccessKeyId?: string | null;
  s3Location?: string | null;
  s3SecretAccessKey?: string | null;
  sKey?: string | null;
  sdkKey?: string | null;
  secretKey?: string | null;
  token?: string | null;
  userId?: string | null;
  userSignature?: string | null;
}

export interface NewWaterfallConfigurationAttributes {
  biddingPriceFloors?: number[] | null;
  biddingStrategy?: WaterfallConfigurationBiddingStrategy | null;
  copiedById?: string | null;
  countryIds?: string[] | null;
  enableBidding?: boolean | null;
  enablePostBid?: boolean | null;
  enablePostBidAutoPriceFloorSteps?: boolean | null;
  lineItems: WaterfallConfigurationLineItemsAttributes;
  name: string;
  postBidPriceFloorSteps?: number[] | null;
  segmentIds?: string[] | null;
  skipAdmobEmergencyAlgorithm?: boolean | null;
  target: WaterfallConfigurationTarget;
  useMaxMonetizationEngine?: boolean | null;
}

export interface PaginationInput {
  page?: number | null;
  pageSize?: number | null;
}

export interface PaymentRequisitesInput {
  abaNumber?: string | null;
  accountName?: string | null;
  accountNumber?: string | null;
  achRoutingNumber?: string | null;
  bankAddress?: string | null;
  bankCountryCode?: string | null;
  bankName?: string | null;
  beneficiaryName?: string | null;
  city?: string | null;
  countryCode?: string | null;
  email?: string | null;
  euros?: boolean | null;
  iban?: string | null;
  intermediaryAccountNumber?: string | null;
  intermediaryBankName?: string | null;
  intermediaryBankSwift?: string | null;
  isUsDomestic?: boolean | null;
  name?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  streetAddress1?: string | null;
  streetAddress2?: string | null;
  swift?: string | null;
  typeOfAccount?: string | null;
  zipCode?: string | null;
}

/**
 * Determines percent of revenue that will be moved to user with email specified in share
 */
export interface RevenueShareInput {
  email: string;
  percent: number;
}

export interface RichMeasureInput {
  day?: number | null;
  id: string;
}

export interface RunSoftLaunchInput {
  adGroupDailyBudget?: string | null;
  adGroupLifeTimeBudget?: string | null;
  appId: string;
  creativeIds: string[];
  headline: string;
  name: string;
  networkAccountId: string;
  primaryText: string;
  targetCountryIds: string[];
}

/**
 * SaveReportFilterAttributes
 */
export interface SaveReportFilterAttributes {
  activityFilter?: SavedDateFilterPeriods | null;
  filters: any;
  installFilter?: SavedDateFilterPeriods | null;
  name: string;
}

export interface ScheduledEventAttributes {
  daysSinceInstall: number;
  eventName: string;
  funnelId: string;
}

export interface SortColumnInput {
  colId?: string | null;
  sort?: SortOrderDirection | null;
}

export interface TestFlowInput {
  appId: string;
  bid?: number | null;
  biddingStrategyGoalType?: string | null;
  budget?: number | null;
  conversionAction?: string | null;
  countries?: string[] | null;
  customerId?: string | null;
  descriptions?: string[] | null;
  headlines?: string[] | null;
  id?: string | null;
  languages?: string[] | null;
  name: string;
  network: string;
  status: string;
}

export interface TextFilter {
  filter: string;
  filterType: string;
  type: string;
}

export interface TextableBooleanFilter {
  filter: string;
  filterType: string;
  type: string;
}

export interface TopFilterInput {
  dimension: Dimension;
  includeOthers?: boolean | null;
  limit: number;
  measure: RichMeasureInput;
  order: TopFilterOrder;
}

export interface UnifiedAppInput {
  androidId: string;
  id?: string | null;
  iosId: string;
  name: string;
}

export interface UpdateAppAttributes {
  bundleId?: string | null;
  coppa?: boolean | null;
  disableAdmobSync?: boolean | null;
  enableStackCmp?: boolean | null;
  filterMatureContent?: boolean | null;
  googlePlayConsoleCredentials?: string | null;
  interstitialMode?: AppInterstitialMode | null;
  mediationEngine?: MediationEngine | null;
  name?: string | null;
  revenueShares?: RevenueShareInput[] | null;
  s2sRewardCallbackKey?: string | null;
  s2sRewardCallbackUrl?: string | null;
  testDeviceIds?: string[] | null;
  testMode?: AppTestMode | null;
  unifiedApp?: UnifiedAppInput | null;
}

export interface UpdateExperimentGroupInput {
  id: string;
  name: string;
}

export interface UpdateExperimentInput {
  cohortLife: number;
  description: string;
  groups: UpdateExperimentGroupInput[];
  id: string;
  name: string;
}

export interface UpdatePasswordAttributes {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}

export interface UpdateProfileAttributes {
  name?: string | null;
  phone?: string | null;
  postalAddress?: string | null;
  skype?: string | null;
  telegram?: string | null;
  timezone?: string | null;
}

/**
 * UpdateReportFilterAttributes
 */
export interface UpdateReportFilterAttributes {
  activityFilter?: SavedDateFilterPeriods | null;
  filters?: any | null;
  installFilter?: SavedDateFilterPeriods | null;
  name?: string | null;
}

export interface UpdateTwoFactorChallengeTypeAttributes {
  confirmationCode?: string | null;
  currentPassword: string;
  twoFactorChallengeType: TwoFactorChallengeType;
}

export interface WaterfallConfigurationLineItemsAttributes {
  automaticPriority: string[];
  bidding?: string[] | null;
  ecpmPriority?: EcpmPriorityLineAttributes[] | null;
  manualPriority: ManualPriorityLineAttributes[];
  postBid?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
